import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Slide from "../Slide/Slide";
import { useMediaQuery } from 'react-responsive';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./styles.css";

// import required modules
import { Pagination } from "swiper";

export default function App({modalControl, setSelected, data}) {

    const [slidesView, setSlidesView] = useState(4);
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    const query900 = useMediaQuery({ query: '(max-width: 900px)' });
    const query675 = useMediaQuery({ query: '(max-width: 675px)' });
    const query450 = useMediaQuery({ query: '(max-width: 450px)' });

    const handleState = function(){
        if(query450){
            setSlidesView(1);
        } else if(query675){
            setSlidesView(2);
        } else if(query900){
            setSlidesView(3);
        } else {
            setSlidesView(4);
        }
    }

    useEffect(()=>{
        
        function handleResize() {
            setWindowSize({
              width: window.innerWidth,
              height: window.innerHeight,
            });
        }
        
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);

    }, []);

    useEffect(()=>{
        handleState();
    },[windowSize]);


  return (
    <>
      <Swiper
        spaceBetween={0}
        slidesPerView={slidesView}
        pagination={{
            clickable: true
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
        {
            data?.map((d,i)=>{
                return <SwiperSlide key={i}><Slide data={d} modalControl={modalControl} setSelected={setSelected}/></SwiperSlide>
            })
        }
      </Swiper>
    </>
  );
}
